import React, { useCallback } from 'react';
import Dropzone, { useDropzone } from "react-dropzone";
import { useDispatch, useSelector } from "react-redux";
import { faUpload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Input } from 'reactstrap';
import { uploadLogo } from "../../../../../context/actions/user";
import './index.scss';
import { validationMessage } from "../../../../../utils/validation";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toasterConfig, imageExtension } from "../../../../../utils/constants";
const UploadLogo = () => {
	const dispatch = useDispatch();
	const userDetail = useSelector((state) => state?.user?.user);


	/*
	* function when drop event occurs
	*/
	const onFileChange = useCallback(
		(acceptedFiles) => {
			if (acceptedFiles && acceptedFiles.length) {
				let formData = new FormData();
				formData.append(`logo`, acceptedFiles[0]);
				formData.append(`fname`, userDetail?.fname);
				dispatch(uploadLogo(formData, userDetail?.organization, (res) => {
					if (res) {
						//setUploadFileStatus(true)
					}

				}))
			}
		},
		[userDetail]
	);

	/**
	 * @description method use to check file type
	 * @param {object} 
	*/
	const fileCheckImg = (obj) => {

		var fileExtension = imageExtension;
		if (obj) {
			if (!fileExtension.includes(obj.name.split('.').pop())) {
				return true;
			}
			return false;
		}
		return false;
	}


	// On file select (from the pop up)
	const onDrop = event => {
		var result = fileCheckImg(event[0]);
		if (!result) {
			onFileChange(event)
		} else {
			toast.error(validationMessage.imageReq, toasterConfig);
		}
	};


	const { open } = useDropzone({ onDrop });
	return (
		<div className='upload-logo-blc position-relative d-inline-flex align-items-center justify-content-center'>
			<Dropzone
				onDrop={onDrop}
				multiple={false}
				maxFiles={1}
			>
				{({ getRootProps, getInputProps, isDragActive }) => (
					<>
						<div className="inner-blc text-center">
							<div
								{...getRootProps()}
								className="flex-fill d-flex flex-column align-items-center justify-content-center dragzone-blc"
							>
								<input {...getInputProps()} />
								{isDragActive ?
									<p>Drop the files here ...</p> :
									<div className="icon-cell">
										<FontAwesomeIcon icon={faUpload} />
										<label className='d-block'>
											Drag & Drop your File to Uploding.
										</label>
									</div>

								}
								<div className={`or-bloc d-flex justify-content-center align-items-center`}>
									<span>OR</span>
								</div>
								<div className="browse-btn-blc">
									<Button
										color="primary"
										className="position-relative"
										onClick={open}
										type="button"
									>
										<Input type="file" id="myInput" onClick={open} className='position-absolute' />
										<input className='position-absolute' onclick="$('#myInput').click();" />
										Browse files
									</Button>
								</div>
							</div>
						</div>
					</>
				)}
			</Dropzone>
		</div>
	);
};

export default UploadLogo;